import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
} from "react";
import "./tabs.scss";
import PostCardList from "../postCardList/postCardList";
import { navigate } from "gatsby";
import { DEFAULT_CATEGORY_SELECTION } from "../../constants/articlesDefaults";
import AccordionDown from "../../assets/images/arrows/ic_chevron_accordian_down.svg";
import AccordionUp from "../../assets/images/arrows/ic_chevron_accordian_up.svg";
import CategoryDropdown from "../../assets/images/arrows/stepper_arrow_down.svg";
import {
  DESKTOP_TAB_CATEGORY_COUNT,
  MOBILE_TAB_CATEGORY_COUNT,
  TABLET_TAB_CATEGORY_COUNT,
  TAB_BREAKPOINT,
} from "../../constants/homePageCategory";
import {
  isDesktop,
  isTablet,
} from "../../utils/breakPoints";

const ListTabDesktop = ({
  selectedCategory,
  categoriesList,
}) => {

  const categoryDropdownRef = useRef(null);

  const defaultCategorySelection = categoriesList.filter(
    item => item.slug === DEFAULT_CATEGORY_SELECTION
  );
  const [
    showCategoryDropdown,
    setShowCategoryDropdown,
  ] = useState(false);

  const [
    defaultCategoryDropdown,
    setDefaultCategoryDropdown,
  ] = useState([]);

  const categoryList = [
    ...defaultCategorySelection,
    ...categoriesList.filter(item => item.count !== null),
  ];

  const toggleCategoryDropdown = () => {
    setShowCategoryDropdown(!showCategoryDropdown);
  };
  const [
    categoryListSlice,
    setCategoryListSlice,
  ] = useState(DESKTOP_TAB_CATEGORY_COUNT);
  const [categoryListTab, setCategoryListTab] = useState(
    []
  );
  const [
    categoryListDropdown,
    setCategoryListDropdown,
  ] = useState([]);

  const getCategoryListTab = useCallback(() => {
    return isDesktop()
      ? categoryList.slice(0, DESKTOP_TAB_CATEGORY_COUNT)
      : isTablet()
        ? categoryList.slice(0, TABLET_TAB_CATEGORY_COUNT)
        : [];
  }, []);

  const getCategoryListDropdown = useCallback(() => {
    return isDesktop()
      ? categoryList.slice(
        DESKTOP_TAB_CATEGORY_COUNT - 1,
        categoryList.length
      )
      : isTablet()
        ? categoryList.slice(
          TABLET_TAB_CATEGORY_COUNT - 1,
          categoryList.length
        )
        : categoryList;
  }, []);

  const getCategoryListSliceCount = useCallback(() => {
    return isDesktop()
      ? DESKTOP_TAB_CATEGORY_COUNT
      : isTablet()
        ? TABLET_TAB_CATEGORY_COUNT
        : MOBILE_TAB_CATEGORY_COUNT;
  });

  const getCategoryListDropdownDefaultCategory = (
    categoryListDropdown,
    selectedCategory
  ) => {
    const defaultCategory = categoryListDropdown.filter(
      item => item.slug === selectedCategory.slug
    );
    if (defaultCategory) {
      return defaultCategory;
    }
    return categoryListDropdown?.length > 0
      ? categoryListDropdown
      : [];
  };

  const handleCloseCategoryDropdown = useCallback((e) => {
    if (categoryDropdownRef.current && showCategoryDropdown && !categoryDropdownRef.current?.contains(e.target)) {
      setShowCategoryDropdown(false);
    }
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const categoryListDropdown = getCategoryListDropdown();
      setCategoryListTab(getCategoryListTab());
      setCategoryListDropdown(categoryListDropdown);
      setCategoryListSlice(getCategoryListSliceCount());
      setDefaultCategoryDropdown(
        getCategoryListDropdownDefaultCategory(
          categoryListDropdown,
          selectedCategory
        )
      );
    }
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("mousedown", handleCloseCategoryDropdown);
      return () => {
        window.removeEventListener("mousedown", handleCloseCategoryDropdown);
      };
    }
  }, [handleCloseCategoryDropdown]);

  return (
    <>
      {categoryListTab.map((item, index) => (
        <li
          key={index}
          onClick={e => {
            e.preventDefault();
            navigate(
              item.slug === DEFAULT_CATEGORY_SELECTION
                ? "/"
                : `/tagged/${item.slug}`,
              { state: { from: "tabs" } }
            );
          }}
          className={
            selectedCategory.slug === item.slug
              ? "tab-title tab-title-active"
              : "tab-title"
          }
        >
          <div className="category-name">{item.name}</div>
        </li>
      ))}
      {categoryList.length > categoryListSlice && (
        <li
          className={`tab-title title-dropdown ${
            defaultCategoryDropdown?.length > 0
              ? "tab-title-active"
              : null
          }`}
          onMouseEnter={toggleCategoryDropdown}
          onClick={toggleCategoryDropdown}
          ref={categoryDropdownRef}
        >
          <div className="category-dropdown-btn">
            <span>
              {defaultCategoryDropdown.length > 0
                ? defaultCategoryDropdown[0].name
                : "More"}
            </span>
            <img
              className="category-dropdown"
              src={CategoryDropdown}
            />
          </div>
          {showCategoryDropdown ? (
            <ul onMouseLeave={toggleCategoryDropdown}>
              {categoryListDropdown.map(item =>
                item.slug !== selectedCategory.slug ? (
                  <li
                    key={item.slug}
                    onClick={() => {
                      navigate(
                        item.slug ===
                          DEFAULT_CATEGORY_SELECTION
                          ? "/"
                          : `/tagged/${item.slug}`,
                        { state: { from: "tabs" } }
                      );
                    }}
                  >
                    {item.name}
                  </li>
                ) : (
                  <li key={item.slug} className="active">
                    {item.name}
                  </li>
                )
              )}
            </ul>
          ) : null}
        </li>
      )}
    </>
  );
};

const ListTabMobile = ({
  selectedCategory,
  categoriesList,
}) => {
  const categoryDropdownRef = useRef();
  const [
    showCategoryDropdown,
    setShowCategoryDropdown,
  ] = useState(false);

  const toggleCategoryDropdown = () => {
    setShowCategoryDropdown(!showCategoryDropdown);
  };
  return (
    <li
      className="tab-title title-dropdown"
      ref={categoryDropdownRef}
    >
      <button
        className="category-dropdown-btn"
        onClick={toggleCategoryDropdown}
      >
        <span>{selectedCategory.name}</span>
        <img
          src={
            showCategoryDropdown
              ? AccordionUp
              : AccordionDown
          }
        />
      </button>
      {showCategoryDropdown ? (
        <ul>
          {categoriesList.map(item =>
            item.slug !== selectedCategory.slug ? (
              <li
                key={item.slug}
                onClick={() => {
                  navigate(
                    item.slug === DEFAULT_CATEGORY_SELECTION
                      ? "/"
                      : `/tagged/${item.slug}`,
                    { state: { from: "tabs" } }
                  );
                  categoryDropdownRef.current.scrollIntoView(
                    {
                      behavior: "smooth",
                      block: "center",
                      inline: "nearest",
                    }
                  );
                }}
              >
                {item.name}
              </li>
            ) : (
              <li key={item.slug} className="active">
                {item.name}
              </li>
            )
          )}
        </ul>
      ) : null}
    </li>
  );
};

const ListTabs = (categoriesList, selectedCategory) => {
  const [deviceWidth, setDeviceWidth] = useState(1024);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const windowInnerWidth = window.innerWidth;
      setDeviceWidth(windowInnerWidth);
    }
  }, []);

  return (
    <>
      {deviceWidth >= TAB_BREAKPOINT ? (
        <ListTabDesktop
          selectedCategory={selectedCategory}
          categoriesList={categoriesList}
        />
      ) : (
        <ListTabMobile
          selectedCategory={selectedCategory}
          categoriesList={categoriesList}
        />
      )}
    </>
  );
};

const ListContent = (categoryList, visibleTab, posts) => {
  return categoryList.map(item => (
    <div
      style={
        visibleTab === item.id ? {} : { display: "none" }
      }
      key={item.id}
    >
      <PostCardList
        posts={posts}
        categoryList={categoryList}
        showMoreVisibility={true}
        showMoreCount={6}
      />
    </div>
  ));
};

const Tabs = data => {
  const defaultCategorySelection = data.categoriesList.nodes.filter(
    item => item.slug === DEFAULT_CATEGORY_SELECTION
  );

  const selectedCategory =
    data.selectedCategory.length > 0
      ? data.selectedCategory[0]
      : defaultCategorySelection[0];

  const categoryList = [
    ...defaultCategorySelection,
    ...data.categoriesList.nodes.filter(
      item => item.count !== null
    ),
  ];

  const posts =
    data.categorySlug === "all-articles"
      ? data.allWpPost.nodes
      : data.categoriesPost.nodes;

  const [visibleTab, setVisibleTab] = React.useState(
    categoryList[0].id
  );

  return (
    <>
      <div className="tabs">
        <ul className="tabs-titles">
          {ListTabs(
            categoryList,
            selectedCategory,
            data.categorySlug
          )}
        </ul>
        <div className="tab-content">
          {ListContent(categoryList, visibleTab, posts)}
        </div>
      </div>
    </>
  );
};

export default Tabs;
